import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DataResolverService } from '../resolver/data-resolver.service';
import { TabsTransportecPage } from './tabs-transportec.page';

const routes: Routes = [
  {
    path: '',
    component: TabsTransportecPage,
    children: [
      {
        path: '',
        redirectTo: '/tecservice-transportec/wallet',
        pathMatch: 'full',
      },
      {
        path: 'wallet',
        children: [
          {
            path: '',
            loadChildren: () => import('./wallet/wallet.module').then((m) => m.WalletPageModule),
          },
          {
            path: 'notifications',
            children: [
              {
                path: '',
                loadChildren: () =>
                  import('../home/notifications/notifications.module').then((m) => m.NotificationsPageModule),
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () =>
                      import('../home/notification/notification.module').then((m) => m.NotificationPageModule),
                  },
                ],
              },
            ],
          },
          {
            path: 'tickets',
            children: [
              {
                path: '',
                loadChildren: () =>
                  import('../home/notifications/notifications.module').then((m) => m.NotificationsPageModule),
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () => import('../home/chat/chat.module').then((m) => m.ChatPageModule),
                  },
                ],
              },
            ],
          },
          {
            path: 'transactions',
            children: [
              {
                path: '',
                loadChildren: () =>
                  import('./wallet/transactions-list/transactions-list.module').then(
                    (m) => m.TransactionsListPageModule
                  ),
              },
              {
                path: ':id/help',
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('../shared/components/help-list/help-list.page').then((m) => m.HelpListPage),
                  },
                  {
                    path: ':type',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadComponent: () => import('../shared/components/help/help.page').then((m) => m.HelpPage),
                  },
                ],
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () => import('./tickets/ticket/ticket.module').then((m) => m.TicketPageModule),
                  },
                ],
              },
            ],
          },
          {
            path: 'balance',
            children: [
              {
                path: '',
                loadChildren: () =>
                  import('./wallet/add-balance/add-balance.module').then((m) => m.AddBalancePageModule),
              },
              {
                path: 'payment-method',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-method/payment-method.module').then((m) => m.PaymentMethodPageModule),
              },
              {
                path: 'payment-card',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-card/payment-card.module').then((m) => m.PaymentCardPageModule),
              },
              {
                path: 'payment-card-openpay',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-card-openpay/payment-card-openpay.module').then(
                    (m) => m.PaymentCardOpenpayPageModule
                  ),
              },
              {
                path: 'payment-card-paycode',
                resolve: {
                  special: DataResolverService,
                },
                loadComponent: () =>
                  import('./wallet/payment-card-paycode/payment-card-paycode.page').then(
                    (m) => m.PaymentCardPayCodePage
                  ),
              },
              {
                path: 'payment-summary',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-summary/payment-summary.module').then((m) => m.PaymentSummaryPageModule),
              },
            ],
          },
        ],
      },
      {
        path: 'subscription',
        children: [
          {
            path: '',
            resolve: {
              special: DataResolverService,
            },
            loadChildren: () => import('./subscription/subscription.module').then((m) => m.SubscriptionPageModule),
          },
          {
            path: 'list',
            loadChildren: () =>
              import('./home/suscriptions-list/suscriptions-list.module').then((m) => m.SuscriptionListPageModule),
          },
          {
            path: 'subscribe-radial-options',
            loadChildren: () =>
              import('./subscription/subscribe-radial-options/subscribe-radial-options.module').then(
                (m) => m.SubscribeRadialOptionsModule
              ),
          },
          {
            path: 'subscribe-radial',
            loadChildren: () =>
              import('./subscription/subscribe-radial/subscribe-radial.module').then(
                (m) => m.SubscribeRadialPageModule
              ),
          },
          {
            path: 'selection',
            resolve: {
              special: DataResolverService,
            },
            loadChildren: () =>
              import('./subscription/selection-summary/selection-summary.module').then(
                (m) => m.SelectionSummaryPageModule
              ),
          },
        ],
      },
      {
        path: 'transportec',
        children: [
          {
            path: '',
            loadChildren: () => import('./home/home.module').then((m) => m.HomePageModule),
          },
          {
            path: 'subscription',
            children: [
              {
                path: '',
                redirectTo: '/tecservice-transportec/transportec/subscription/list',
                pathMatch: 'full',
              },
              {
                path: 'list',
                loadChildren: () =>
                  import('./home/suscriptions-list/suscriptions-list.module').then((m) => m.SuscriptionListPageModule),
              },
            ],
          },
          {
            path: 'selection',
            resolve: {
              special: DataResolverService,
            },
            loadChildren: () =>
              import('./subscription/selection-summary/selection-summary.module').then(
                (m) => m.SelectionSummaryPageModule
              ),
          },
          {
            path: 'help-list',
            loadComponent: () => import('../shared/components/help-list/help-list.page').then((m) => m.HelpListPage),
          },
          {
            path: 'zones',
            children: [
              {
                path: '',
                resolve: {
                  special: DataResolverService,
                },
                loadComponent: () => import('./components/zones/zones.page').then((m) => m.ZonesPage),
              },
            ],
          },
          {
            path: 'routes',
            children: [
              {
                path: '',
                resolve: {
                  special: DataResolverService,
                },
                loadComponent: () => import('./components/routes/routes.page').then((m) => m.RoutesPage),
              },
            ],
          },
          {
            path: 'route',
            children: [
              {
                path: '',
                redirectTo: '/tecservice-transportec/transportec/routes',
                pathMatch: 'full',
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadComponent: () => import('./components/route/route.page').then((m) => m.RoutePage),
                  },
                ],
              },
            ],
          },
          {
            path: 'route-map',
            children: [
              {
                path: '',
                redirectTo: '/tecservice-transportec/transportec/routes',
                pathMatch: 'full',
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadComponent: () => import('./components/route-map/route-map.page').then((m) => m.RouteMapPage),
                  },
                ],
              },
            ],
          },
          {
            path: 'tickets',
            children: [
              {
                path: '',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./home/tickets-search/tickets-search.module').then((m) => m.TicketsSearchPageModule),
              },
            ],
          },
          {
            path: 'search',
            children: [
              {
                path: '',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./home/tickets-search-results/tickets-search-results.module').then(
                    (m) => m.TicketsSearchResultsPageModule
                  ),
              },
            ],
          },
          {
            path: 'ticket-summary',
            children: [
              {
                path: '',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./home/ticket-summary/ticket-summary.module').then((m) => m.TicketSummaryPageModule),
              },
              {
                path: 'payment-card',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-card/payment-card.module').then((m) => m.PaymentCardPageModule),
              },
              {
                path: 'payment-card-openpay',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-card-openpay/payment-card-openpay.module').then(
                    (m) => m.PaymentCardOpenpayPageModule
                  ),
              },
              {
                path: 'payment-card-paycode',
                resolve: {
                  special: DataResolverService,
                },
                loadComponent: () =>
                  import('./wallet/payment-card-paycode/payment-card-paycode.page').then(
                    (m) => m.PaymentCardPayCodePage
                  ),
              },
            ],
          },
          {
            path: 'subscribe',
            children: [
              {
                path: '',
                loadChildren: () => import('./subscribe/subscribe.module').then((m) => m.SubscribePageModule),
              },
              {
                path: 'payment-method',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./subscription/payment-method/payment-method.module').then((m) => m.PaymentMethodPageModule),
              },
              {
                path: 'payment-card',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-card/payment-card.module').then((m) => m.PaymentCardPageModule),
              },
              {
                path: 'payment-card-openpay',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-card-openpay/payment-card-openpay.module').then(
                    (m) => m.PaymentCardOpenpayPageModule
                  ),
              },
              {
                path: 'payment-card-paycode',
                resolve: {
                  special: DataResolverService,
                },
                loadComponent: () =>
                  import('./wallet/payment-card-paycode/payment-card-paycode.page').then(
                    (m) => m.PaymentCardPayCodePage
                  ),
              },
              {
                path: 'payment-summary',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () =>
                  import('./wallet/payment-summary/payment-summary.module').then((m) => m.PaymentSummaryPageModule),
              },
            ],
          },
          {
            path: 'subscription',
            children: [
              {
                path: '',
                redirectTo: '/tecservice-transportec/transportec',
                pathMatch: 'full',
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () => import('./tickets/ticket/ticket.module').then((m) => m.TicketPageModule),
                  },
                ],
              },
            ],
          },
          {
            path: 'notifications',
            children: [
              {
                path: '',
                loadChildren: () =>
                  import('../home/notifications/notifications.module').then((m) => m.NotificationsPageModule),
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () =>
                      import('../home/notification/notification.module').then((m) => m.NotificationPageModule),
                  },
                ],
              },
            ],
          },
          {
            path: 'transactions',
            loadChildren: () =>
              import('./wallet/transactions-list/transactions-list.module').then((m) => m.TransactionsListPageModule),
          },
          {
            path: 'balance',
            children: [
              {
                path: '',
                loadChildren: () =>
                  import('./wallet/add-balance/add-balance.module').then((m) => m.AddBalancePageModule),
              },
              {
                path: 'payment-method',
                loadChildren: () =>
                  import('./wallet/payment-method/payment-method.module').then((m) => m.PaymentMethodPageModule),
              },
              {
                path: 'payment-summary',
                loadChildren: () =>
                  import('./wallet/payment-summary/payment-summary.module').then((m) => m.PaymentSummaryPageModule),
              },
            ],
          },
        ],
      },
      {
        path: 'tickets',
        children: [
          {
            path: '',
            loadChildren: () => import('./tickets/tickets.module').then((m) => m.TicketsPageModule),
          },
          {
            path: 'ticket',
            children: [
              {
                path: '',
                redirectTo: '/tecservice-transportec/tickets',
                pathMatch: 'full',
              },
              {
                path: ':id/help',
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('../shared/components/help-list/help-list.page').then((m) => m.HelpListPage),
                  },
                  {
                    path: ':type',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadComponent: () => import('../shared/components/help/help.page').then((m) => m.HelpPage),
                  },
                ],
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () => import('./tickets/ticket/ticket.module').then((m) => m.TicketPageModule),
                  },
                ],
              },
            ],
          },
          {
            path: 'notifications',
            children: [
              {
                path: '',
                loadChildren: () =>
                  import('../home/notifications/notifications.module').then((m) => m.NotificationsPageModule),
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () =>
                      import('../home/notification/notification.module').then((m) => m.NotificationPageModule),
                  },
                ],
              },
            ],
          },
          {
            path: 'transactions',
            loadChildren: () =>
              import('./wallet/transactions-list/transactions-list.module').then((m) => m.TransactionsListPageModule),
          },
          {
            path: 'balance',
            children: [
              {
                path: '',
                loadChildren: () =>
                  import('./wallet/add-balance/add-balance.module').then((m) => m.AddBalancePageModule),
              },
              {
                path: 'payment-method',
                loadChildren: () =>
                  import('./wallet/payment-method/payment-method.module').then((m) => m.PaymentMethodPageModule),
              },
              {
                path: 'payment-summary',
                loadChildren: () =>
                  import('./wallet/payment-summary/payment-summary.module').then((m) => m.PaymentSummaryPageModule),
              },
            ],
          },
        ],
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            loadChildren: () => import('../profile/profile.module').then((m) => m.ProfilePageModule),
          },
          {
            path: 'billing',
            loadChildren: () =>
              import('../shared/components/billing-info/billing-info.module').then((m) => m.BillingInfoModule),
          },
          {
            path: 'settings',
            children: [
              {
                path: '',
                resolve: {
                  special: DataResolverService,
                },
                loadChildren: () => import('../register/register.module').then((m) => m.RegisterPageModule),
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    resolve: {
                      special: DataResolverService,
                    },
                    loadChildren: () => import('../register/register.module').then((m) => m.RegisterPageModule),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsTransportecPageRoutingModule {}
